import Alert from '../Alert';
import React from 'react';

/*
  Alerts users about service breaks.
 */
export const ServiceAlert = () => {
  return (
    <Alert type="error">
      <p>
        Ajalla 22.12.2025- 11.1.2026 saattaa osalla hoitoyksiköistä olla poikkeavia aukioloaikoja tai hoitoyksiköitä voi olla tilapäisesti suljettu.
        Aukioloajat näet Pirkanmaan hyvinvointialueen verkkosivuilta.
        Hoitokeskusteluviesteihin vastataan hoitoyksiköiden aukioloaikoina.
        Kiireellisissä asioissa ole yhteydessä päivystykseen.
      </p>
    </Alert>
  );
};
